module.exports = __webpack_public_path__ + "static/media/galerija_2022_0038.e92c51d7.jpg";